/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DigitaloceanDropletsListRsp } from '../models/digitalocean-droplets-list-rsp';
import { DigitaloceanDropletsCreateRsp } from '../models/digitalocean-droplets-create-rsp';
import { DigitaloceanDropletsCreateReq } from '../models/digitalocean-droplets-create-req';
import { DigitaloceanDropletsLookupRsp } from '../models/digitalocean-droplets-lookup-rsp';
import { DigitaloceanDropletsDeleteRsp } from '../models/digitalocean-droplets-delete-rsp';
import { RuntimeStreamError } from '../models/runtime-stream-error';
import { DigitaloceanChunk } from '../models/digitalocean-chunk';
import { DigitaloceanDropletsMetricsRsp } from '../models/digitalocean-droplets-metrics-rsp';
import { DigitaloceanActionRsp } from '../models/digitalocean-action-rsp';
import { DigitaloceanActionReq } from '../models/digitalocean-action-req';
@Injectable({
  providedIn: 'root',
})
class DropletsServiceService extends __BaseService {
  static readonly DropletsListPath = '/api/digitalocean/v2/droplets';
  static readonly DropletsCreatePath = '/api/digitalocean/v2/droplets';
  static readonly DropletsLookupPath = '/api/digitalocean/v2/droplets/{id}';
  static readonly DropletsDeletePath = '/api/digitalocean/v2/droplets/{id}';
  static readonly DropletsConsolePath = '/api/digitalocean/v2/droplets/{id}/console';
  static readonly DropletsLogsPath = '/api/digitalocean/v2/droplets/{id}/logs';
  static readonly DropletsMetricsPath = '/api/digitalocean/v2/droplets/{id}/metrics';
  static readonly DropletsActionCreatePath = '/api/digitalocean/v2/droplets/{resource_id}/actions';
  static readonly DropletsActionLookupPath = '/api/digitalocean/v2/droplets/{resource_id}/actions/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `DropletsServiceService.DropletsListParams` containing the following parameters:
   *
   * - `tag_name`:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DropletsListResponse(params: DropletsServiceService.DropletsListParams): __Observable<__StrictHttpResponse<DigitaloceanDropletsListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.tagName != null) __params = __params.set('tag_name', params.tagName.toString());
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDropletsListRsp>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsListParams` containing the following parameters:
   *
   * - `tag_name`:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DropletsList(params: DropletsServiceService.DropletsListParams): __Observable<DigitaloceanDropletsListRsp> {
    return this.DropletsListResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDropletsListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  DropletsCreateResponse(body: DigitaloceanDropletsCreateReq): __Observable<__StrictHttpResponse<DigitaloceanDropletsCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/droplets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDropletsCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  DropletsCreate(body: DigitaloceanDropletsCreateReq): __Observable<DigitaloceanDropletsCreateRsp> {
    return this.DropletsCreateResponse(body).pipe(
      __map(_r => _r.body as DigitaloceanDropletsCreateRsp)
    );
  }

  /**
   * @param params The `DropletsServiceService.DropletsLookupParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DropletsLookupResponse(params: DropletsServiceService.DropletsLookupParams): __Observable<__StrictHttpResponse<DigitaloceanDropletsLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDropletsLookupRsp>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsLookupParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  DropletsLookup(params: DropletsServiceService.DropletsLookupParams): __Observable<DigitaloceanDropletsLookupRsp> {
    return this.DropletsLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDropletsLookupRsp)
    );
  }

  /**
   * @param params The `DropletsServiceService.DropletsDeleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `tag_name`:
   *
   * @return A successful response.
   */
  DropletsDeleteResponse(params: DropletsServiceService.DropletsDeleteParams): __Observable<__StrictHttpResponse<DigitaloceanDropletsDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.tagName != null) __params = __params.set('tag_name', params.tagName.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/digitalocean/v2/droplets/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDropletsDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsDeleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `tag_name`:
   *
   * @return A successful response.
   */
  DropletsDelete(params: DropletsServiceService.DropletsDeleteParams): __Observable<DigitaloceanDropletsDeleteRsp> {
    return this.DropletsDeleteResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanDropletsDeleteRsp)
    );
  }

  /**
   * @param params The `DropletsServiceService.DropletsConsoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  DropletsConsoleResponse(params: DropletsServiceService.DropletsConsoleParams): __Observable<__StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanChunk}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.type != null) __params = __params.set('type', params.type.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets/${params.id}/console`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanChunk}>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsConsoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  DropletsConsole(params: DropletsServiceService.DropletsConsoleParams): __Observable<{error?: RuntimeStreamError, result?: DigitaloceanChunk}> {
    return this.DropletsConsoleResponse(params).pipe(
      __map(_r => _r.body as {error?: RuntimeStreamError, result?: DigitaloceanChunk})
    );
  }

  /**
   * @param id undefined
   * @return A successful response.(streaming responses)
   */
  DropletsLogsResponse(id: string): __Observable<__StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanChunk}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets/${id}/logs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanChunk}>;
      })
    );
  }
  /**
   * @param id undefined
   * @return A successful response.(streaming responses)
   */
  DropletsLogs(id: string): __Observable<{error?: RuntimeStreamError, result?: DigitaloceanChunk}> {
    return this.DropletsLogsResponse(id).pipe(
      __map(_r => _r.body as {error?: RuntimeStreamError, result?: DigitaloceanChunk})
    );
  }

  /**
   * @param id undefined
   * @return A successful response.
   */
  DropletsMetricsResponse(id: string): __Observable<__StrictHttpResponse<DigitaloceanDropletsMetricsRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets/${id}/metrics`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanDropletsMetricsRsp>;
      })
    );
  }
  /**
   * @param id undefined
   * @return A successful response.
   */
  DropletsMetrics(id: string): __Observable<DigitaloceanDropletsMetricsRsp> {
    return this.DropletsMetricsResponse(id).pipe(
      __map(_r => _r.body as DigitaloceanDropletsMetricsRsp)
    );
  }

  /**
   * @param params The `DropletsServiceService.DropletsActionCreateParams` containing the following parameters:
   *
   * - `resource_id`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DropletsActionCreateResponse(params: DropletsServiceService.DropletsActionCreateParams): __Observable<__StrictHttpResponse<DigitaloceanActionRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/droplets/${params.resourceId}/actions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanActionRsp>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsActionCreateParams` containing the following parameters:
   *
   * - `resource_id`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  DropletsActionCreate(params: DropletsServiceService.DropletsActionCreateParams): __Observable<DigitaloceanActionRsp> {
    return this.DropletsActionCreateResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanActionRsp)
    );
  }

  /**
   * @param params The `DropletsServiceService.DropletsActionLookupParams` containing the following parameters:
   *
   * - `resource_id`:
   *
   * - `id`:
   *
   * - `type`:
   *
   * @return A successful response.
   */
  DropletsActionLookupResponse(params: DropletsServiceService.DropletsActionLookupParams): __Observable<__StrictHttpResponse<DigitaloceanActionRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.type != null) __params = __params.set('type', params.type.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/droplets/${params.resourceId}/actions/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanActionRsp>;
      })
    );
  }
  /**
   * @param params The `DropletsServiceService.DropletsActionLookupParams` containing the following parameters:
   *
   * - `resource_id`:
   *
   * - `id`:
   *
   * - `type`:
   *
   * @return A successful response.
   */
  DropletsActionLookup(params: DropletsServiceService.DropletsActionLookupParams): __Observable<DigitaloceanActionRsp> {
    return this.DropletsActionLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanActionRsp)
    );
  }
}

module DropletsServiceService {

  /**
   * Parameters for DropletsList
   */
  export interface DropletsListParams {
    tagName?: string;
    perPage?: string;
    page?: string;
    fields?: Array<'field_all' | 'field_id' | 'field_name' | 'field_vcpus' | 'field_disk' | 'field_memory'>;
  }

  /**
   * Parameters for DropletsLookup
   */
  export interface DropletsLookupParams {
    id: string;
    fields?: Array<'field_all' | 'field_id' | 'field_name' | 'field_vcpus' | 'field_disk' | 'field_memory'>;
  }

  /**
   * Parameters for DropletsDelete
   */
  export interface DropletsDeleteParams {
    id: string;
    tagName?: string;
  }

  /**
   * Parameters for DropletsConsole
   */
  export interface DropletsConsoleParams {
    id: string;
    type?: 'invalid' | 'vnc' | 'rfb' | 'spice' | 'term';
  }

  /**
   * Parameters for DropletsActionCreate
   */
  export interface DropletsActionCreateParams {
    resourceId: string;
    body: DigitaloceanActionReq;
  }

  /**
   * Parameters for DropletsActionLookup
   */
  export interface DropletsActionLookupParams {
    resourceId: string;
    id: string;
    type?: string;
  }
}

export { DropletsServiceService }
